import { useEffect, useState } from "react";
import { useLocation, } from "react-router-dom";
import { Card, CardFooter, CardHeader, Container, Row, Table, Input } from "reactstrap";
import TablePagination from "views/components/TablePagination";
import { filterItems, formatDateTime } from "lib/helper";
import ExportButton from "components/ExportButton";
import FormsModel from "models/forms.model";
import { helper } from "lib/helper";
import TableHeader from "components/TableHeader/TableHeader";

const Listing = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);

  const [searchQuery, setSearchQuery] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const location = useLocation();



  const getListData = async () => {
    setIsLoading(true);
    try {
      const result = await FormsModel.partnership();
      if (result) { setDataList(result?.data?.data); }
    } catch (error) {
      helper.sweetalert.toast(error.response?.data?.message, "warning");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { getListData(); }, [location]);
  useEffect(() => { setCurrentPage(1); }, [searchQuery, fromDate, toDate]);

  const dateFilteredList = dataList.filter((item) => {
    const createdAt = new Date(item.createdAt);
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;
    return (!from || createdAt >= from) && (!to || createdAt <= to);
  });

  const filteredDataList = filterItems(
    dateFilteredList.map((e) => ({ ...e.hostedBy, ...e })),
    searchQuery,
    [
      "Organization Name",
      "Contact person",
      "Designation",
      "Partnership type",
      "City region",
      "Partnership vision",
      "Expected audience size",
      "Expected audience size",
      "Preferred duration",
      "Estimated budget",
      "website",
      "Primary social media",
      "previous partnership experience",
      "heard about us",
      "Supporting documents",
      "Added On"
    ]
  );
  const startIndex = (currentPage - 1) * perPage;
  const paginatedDataList = filteredDataList.slice(startIndex, startIndex + perPage);

  const handlePageChange = (pageNumber) => { setCurrentPage(pageNumber); };

  const columnsConfig = [
    {
      label: "S.No",
      getValue: (_, index) => startIndex + index + 1
    },
    {
      label: "Organization",
      getValue: (item) => item?.organization_name
    },
    {
      label: "Contact Person",
      getValue: (item) => `${item?.contact_person} ${item?.contact_email} (${item?.contact_number})`,
    },
    {
      label: "Designation",
      getValue: (item) => item?.designation
    },
    {
      label: "Partnership type",
      getValue: (item) => item?.partnership_type
    },
    {
      label: "City region",
      getValue: (item) => item?.city_region,
    },
    {
      label: "Vision",
      getValue: (item) => item?.partnership_vision,
    },
    {
      label: "Audience size",
      getValue: (item) => item?.expected_audience_size,
    },
    {
      label: "Duration",
      getValue: (item) => item?.preferred_duration,
    },
    {
      label: "Budget",
      getValue: (item) => item?.estimated_budget,
    },
    {
      label: "Website",
      getValue: (item) => item?.website,
    },
    {
      label: "Social media",
      getValue: (item) => item?.primary_social_media,
    },
    {
      label: "Previous experience",
      getValue: (item) => item?.previous_partnership_experience,
    },
    {
      label: "Heard about us",
      getValue: (item) => item?.heard_about_us,
    },
  ];


  return (
    <Container className="pt-7" fluid>
      {!isLoading && (
        <Row>
          <div className="col pl-0 pr-0">
            <Card className="shadow">
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Partnership</h3>
                <div className="d-flex align-items-center">
                  <div>
                    <lebal className="text-sm">Search</lebal>
                    <Input
                      type="text"
                      placeholder="Search Here..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{ width: "200px", marginRight: "10px" }}
                    />
                  </div>
                  {/* <div>
                    <lebal className="text-sm">To date</lebal>
                    <Input
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      style={{ marginRight: "10px" }}
                    />
                  </div>
                  <div className="ml-2">
                    <lebal className="">Form date</lebal>
                    <Input
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      style={{ marginRight: "10px" }}
                    />
                  </div> */}
                  <div className=" ml-3 mt-4">
                    <ExportButton data={filteredDataList} columnsConfig={columnsConfig} />
                  </div>
                </div>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <TableHeader options={[
                  "#",
                  "Organization",
                  "Contact person",
                  "Designation",
                  "Partnership type",
                  "City region",
                  "Partnership vision",
                  "Audience size",
                  "Preferred duration",
                  "Estimated budget",
                  "Website",
                  "Social media",
                  "Partnership experience",
                  "Heard about us",
                  "Supporting documents",
                  "Added On"
                ]} />
                <tbody>
                  {paginatedDataList.map((item, index) => (
                    <tr key={item._id}>
                      <td>{startIndex + index + 1}</td>
                      <td>{item?.organization_name}</td>
                      <td>
                        <div className="fw-semibold">{item?.contact_person}</div>
                        <div className="text-muted small">
                          {item?.contact_email}
                          {item?.contact_number ? ` • ${item.contact_number}` : ""}
                        </div>
                      </td>
                      <td>{item?.designation}</td>
                      <td>{item?.partnership_type}</td>
                      <td>{item?.city_region}</td>
                      <td>{item?.partnership_vision}</td>
                      <td>{item?.expected_audience_size}</td>
                      <td>{item?.preferred_duration}</td>
                      <td>{item?.estimated_budget}</td>
                      <td>{item?.website}</td>
                      <td>{item?.primary_social_media}</td>
                      <td>{item?.previous_partnership_experience}</td>
                      <td>{item?.heard_about_us}</td>
                      {/* //supporting_documents */}<td>{ }</td>
                      <td>{formatDateTime(item?.createdAt)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <TablePagination
                  totalPages={Math.ceil(filteredDataList.length / perPage)}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
      )}
    </Container>


  );
};

export default Listing;
